import { schoolsSlice } from "./slice";

export const { setSelectedSession, setSelectedMedium, resetSchoolSlice } =
  schoolsSlice.actions;
